import { Badge, Input, Label } from '@@/ui/primitives';

interface StringInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}

export function StringInput({ value, onChange, disabled = false, label, placeholder }: StringInputProps) {
  return (
    <div className='space-y-2'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          String
        </Badge>
      </div>
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className='text-sm! font-medium! bg-white w-full'
        disabled={disabled}
      />
    </div>
  );
}
